module.exports = __webpack_public_path__ + "images/bedroom-e33282b58c042e26424c4641a84267ee.jpg";